import { Box } from '@chakra-ui/react'
import type { FC } from 'react'

export const NavbarDivider: FC = () => <Box height='1px' width='calc(100% - 32px)' margin='16px' backgroundColor={'gray.50'} />
